// extracted by mini-css-extract-plugin
export var bottomwrapper = "Footer-module--bottomwrapper--b5491";
export var cookiebutton = "Footer-module--cookiebutton--8e30d";
export var footerbottom = "Footer-module--footerbottom--8b3ee";
export var footercomponent = "Footer-module--footercomponent--7e412";
export var footertop = "Footer-module--footertop--cd10c";
export var footerwrapper = "Footer-module--footerwrapper--62fc8";
export var legalwrapper = "Footer-module--legalwrapper--352ca";
export var legalwrapperheader = "Footer-module--legalwrapperheader--31ad6";
export var legalwrapperp = "Footer-module--legalwrapperp--ecf45";
export var link = "Footer-module--link--41ebd";
export var links = "Footer-module--links--397b6";
export var newsletterwrapper = "Footer-module--newsletterwrapper--ac900";
export var sectionbreakbottom = "Footer-module--sectionbreakbottom--04926";
export var sectionbreakmiddle = "Footer-module--sectionbreakmiddle--b5b08";
export var sectionbreaktop = "Footer-module--sectionbreaktop--3ef5a";
export var socialmediawrapper = "Footer-module--socialmediawrapper--a1e8d";
export var usefullinkstitle = "Footer-module--usefullinkstitle--91780";
export var usefullinkswrapper = "Footer-module--usefullinkswrapper--916ce";